var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomedepotReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.homedepot{fill:url(#homedepot-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "homedepot-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ff7200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5451"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "homedepot",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M69.3866,35.0332l-16.68805-8.76831c-1.68951-.8877-3.70758-.8877-5.39709,0l-16.68805,8.76831c-1.9082,1.00262-3.10321,2.98047-3.10321,5.13599v28.42993c0,3.20422,2.59753,5.80176,5.80176,5.80176h33.3761c3.20422,0,5.80176-2.59753,5.80176-5.80176v-28.42993c0-2.15552-1.19501-4.13336-3.10321-5.13599ZM61.42505,52.01825l-4.15466,4.50238.71466,6.08447c.15613,1.32935-1.20312,2.31708-2.41913,1.75769l-5.56598-2.55994-5.56586,2.55994c-1.216.55939-2.57538-.42834-2.41925-1.75769l.71478-6.08447-4.15466-4.50238c-.90765-.9837-.38843-2.58167.92413-2.84393l6.00751-1.20056,2.99823-5.34259c.65503-1.16724,2.33521-1.16724,2.99036,0l2.99823,5.34259,6.00751,1.20056c1.31256.26227,1.83179,1.86023.92413,2.84393Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomedepotReviewsScraper);
export default __webpack_public_path__ + "static/media/homedepot-reviews-scraper.0fd0b201fa0c748462cff29944df5490.svg";
export { ForwardRef as ReactComponent };